module.exports = __webpack_public_path__ + "static/media/banner.cc433dc2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/imgs/banner.jpg
// module id = 2305
// module chunks = 0